import demoVideo from "@/assets/DemoVideo.webp";
import InsightCard from "./InsightCards";

const DemoVideo = () => {
    return <div className="">
        <div className="flex flex-col items-center justify-center gap-8 px-4 md:px-0 text-left  md:text-center">
            <h2 className="text-[34px] md:text-5xl font-semibold text-gray-800 mb-2 leading-normal  md:leading-relaxed ">

                Top AI Recruitment Solution for Automated Hiring
            </h2>
            <p className="md:text-lg font-light max-w-full md:w-[900px] md:text-center ">
                At Talentick.ai, we're reshaping how companies hire top talent. Traditional hiring methods are slow and often fail to fairly identify the right candidates. Our AI platform helps you find top talent faster through unbiased assessments and clear insights, enabling confident decisions.
            </p>
        </div>

        <div className="hidden md:block mt-20">
            <img src={demoVideo} alt="demo-video" className="w-full max-h-[85vh]  mx-auto" />
        </div>

        <div className="md:hidden mt-8 md:mt-20 mb-12 px-4 md:px-0">
            <img
                src={demoVideo}
                alt="demo-video"
                className="w-full   object-fill mx-auto rounded-lg"
            />
        </div>


        <InsightCard />
    </div>;
};

export default DemoVideo;


